import PersonIcon from '@mui/icons-material/Person';

export const UserIcon = PersonIcon;
